// These values are taken from the back end.
// If they are changed there, then it is needed to change them here

export enum goodTargetGroups {
    women = '7c593561-c965-4dbb-9bca-f6ec8c9a8959',
    men = 'f1b15243-ea2a-4dcf-b132-7328f06863ca',
    unisex = '790a2dd7-237b-4483-a60e-75ab1f1ad344',
    child = '34d5270d-cdf3-4ef7-b727-186ebdad04c1',
}
